import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { AllRotorsCustomEvent } from '../../shared/enum';

@Component({
  selector: 'app-sign-up-form-container',
  template: `
    <ion-content>
      <app-signup-forgot-password [underIframe]="true" [isSignUp]="true"></app-signup-forgot-password>
    </ion-content>
  `,
  styleUrls: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SignUpFormContainerComponent {
  ionViewWillEnter() {
    window.parent.postMessage(AllRotorsCustomEvent.COMPONENT_LOADED, '*');
  }
}
